export const initAos = async (params: object = {}) => {
    if (import.meta.server) {
        return;
    }

    const [{ default: AOS }] = await Promise.all([
        import('aos'),
        import('aos/dist/aos.css'),
    ]);

    AOS.init(params);
};
